import createReducer from 'lib/create-reducer'
import { constants } from './actions'

const defaultState = {
  selectedPapers: [],
  modalCopy: {
    title: '',
    descriptionP1: '',
    descriptionP2: ''
  },
  modalAnalytics: {
    category: '',
    label: ''
  }
}

const addReportDashboardModal = createReducer(defaultState, {
  [constants.SET_SELECTED_PAPERS]: (state, selectedPapers) => ({
    ...state,
    selectedPapers
  }),
  [constants.CLEAR_SELECTED_PAPERS]: state => ({
    ...state,
    selectedPapers: []
  }),
  [constants.FLUSH_ADD_REPORT_DASHBOARD_MODAL]: state => ({
    ...defaultState
  }),
  [constants.SET_MODAL_COPY]: (state, modalCopy) => ({
    ...state,
    modalCopy
  }),
  [constants.SET_MODAL_ANALYTICS]: (state, modalAnalytics) => ({
    ...state,
    modalAnalytics
  })
})

export default addReportDashboardModal
